import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'app-show-discount',
  templateUrl: './show-discount.component.html',
  styleUrls: ['./show-discount.component.scss']
})
export class ShowDiscountComponent implements OnInit {

  @Input() discount: any;

  constructor(
    public activeModal: NgbActiveModal,
    private _clipboardService: ClipboardService) {}

  ngOnInit(): void { }

  public closeBtnClick() {
    this.activeModal.close();
  }

  public goToReferrelLink(offer) {
    this._clipboardService.copy(offer.code);
    window.open(offer.affiliate_url || offer.offer_url, '_blank');
  }
}
